module.exports = __webpack_public_path__ + "media/images/edion/top/7-dad2c3446f8696d87b7f9808ce943818.png";